'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCardText = require('../ContentCardText');

var _ContentCardText2 = _interopRequireDefault(_ContentCardText);

var _ContentCardHeader = require('../ContentCardHeader');

var _ContentCardHeader2 = _interopRequireDefault(_ContentCardHeader);

var _ContentCardVideo = require('../ContentCardVideo');

var _ContentCardVideo2 = _interopRequireDefault(_ContentCardVideo);

var _withContentCardFooter = require('../../hocs/withContentCardFooter');

var _withContentCardFooter2 = _interopRequireDefault(_withContentCardFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InstagramVideoContentCard = function (_React$Component) {
  _inherits(InstagramVideoContentCard, _React$Component);

  function InstagramVideoContentCard(props) {
    _classCallCheck(this, InstagramVideoContentCard);

    var _this = _possibleConstructorReturn(this, (InstagramVideoContentCard.__proto__ || Object.getPrototypeOf(InstagramVideoContentCard)).call(this, props));

    _this.state = {
      videoPlaying: false
    };

    _this.onVideoPlayed = _this.onVideoPlayed.bind(_this);
    _this.onVideoStopped = _this.onVideoStopped.bind(_this);
    return _this;
  }

  _createClass(InstagramVideoContentCard, [{
    key: 'onVideoPlayed',
    value: function onVideoPlayed() {
      this.setState({
        videoPlaying: true
      });
    }
  }, {
    key: 'onVideoStopped',
    value: function onVideoStopped() {
      this.setState({
        videoPlaying: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ContentCardVideo2.default, {
          onPlayCallback: this.onVideoPlayed,
          onStopCallback: this.onVideoStopped,
          poster: this.props.posterURL,
          src: this.props.videoURL,
          trackEvent: this.props.trackEvent,
          type: 'instagram',
          modalEnabled: this.props.modalEnabled,
          isLarge: this.props.isLarge
        }),
        !this.state.videoPlaying && _react2.default.createElement(_ContentCardHeader2.default, { isLarge: this.props.isLarge, iconType: 'instagram' }),
        _react2.default.createElement(
          'a',
          { href: this.props.mediaPageUri, target: '_blank', rel: 'noopener noreferrer' },
          _react2.default.createElement(_ContentCardText2.default, {
            videoPlaying: this.state.videoPlaying,
            text: this.props.text,
            isLarge: this.props.isLarge
          })
        ),
        this.props.messengerShareButton
      );
    }
  }]);

  return InstagramVideoContentCard;
}(_react2.default.Component);

InstagramVideoContentCard.propTypes = {
  authorHandle: _propTypes2.default.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  mediaPageUri: _propTypes2.default.string,
  messengerShareButton: _propTypes2.default.node,
  posterURL: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string.isRequired,
  videoURL: _propTypes2.default.string.isRequired,
  trackEvent: _propTypes2.default.func,
  modalEnabled: _propTypes2.default.bool,
  isLarge: _propTypes2.default.bool
};

InstagramVideoContentCard.defaultProps = {
  mediaPageUri: null,
  messengerShareButton: null,
  trackEvent: null,
  caption: '',
  modalEnabled: _propTypes2.default.bool,
  isLarge: false
};

InstagramVideoContentCard.displayName = 'InstagramVideoContentCard';

exports.default = (0, _withContentCardFooter2.default)(InstagramVideoContentCard);